import { usePick, type Language } from "@vcn/ui";
import * as de from "./de";
import * as en from "./en";

/** Struktur der Seiteninhalte – die deutsche Fassung ist die Referenz. */
export type Content = typeof de;

const content: Record<Language, Content> = { de, en };

/** Inhalte in der aktuell gewählten Sprache. */
export function useContent(): Content {
  return usePick(content);
}

export type { CapModule, Benefit } from "./de";
